import { IonButton, IonCol, IonRow } from '@ionic/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { TimelineConstants } from '../../features/timeline/store/timeline.constants'
import ZToggle from '../zToggle/Toggle.component'
import './GridHeaderRow.component.css'

const GridHeaderRow = (): JSX.Element => {
  const dispatch = useDispatch()

  // todo: pass dispatch type as prop
  return (
    <IonRow qa-id='item_grid_header_row'>
      <IonCol qa-id='item_grid_header_row_column_label' className='ion-margin-start'>
        <p qa-id='item_grid_header_row_label_name' className='grid-title'>
          Activity Log
        </p>
      </IonCol>
      <ZToggle label='Show Vitals Only' />
      <IonCol qa-id='item_grid_header_row_column_button' className='fit-to-screen' size='1.1'>
        <IonButton
          className='btn btn-primary'
          qa-id='item_grid_header_row_button_name'
          onClick={() => {
            dispatch({ type: TimelineConstants.ADD_VITALS })
          }}>
          ADD+
        </IonButton>
      </IonCol>
    </IonRow>
  )
}

export default GridHeaderRow
